const en = {
  part: 'Part',
  partColor: 'Part Color',
  equipment: 'Equipment',
  order: 'Order',
  color: 'Color',
  category: 'Category',
  brand: 'Brand',
  customer: 'Customer',
  dealer: 'Dealer',
  device: 'Device',
  detailsSuffix: '{{label}} Details',
  errorLoading: 'Error Loading {{label}}',
  tryAgain: 'Try Again',
  noDataFound: 'No Data Found',
  unknownEntityType: 'Unknown Entity Type: {{type}}',
};

const de = {
  part: 'Teil',
  partColor: 'Teilfarbe',
  equipment: 'Ausrüstung',
  order: 'Bestellung',
  color: 'Farbe',
  category: 'Kategorie',
  brand: 'Marke',
  customer: 'Kunde',
  dealer: 'Händler',
  device: 'Gerät',
  detailsSuffix: '{{label}}-Details',
  errorLoading: 'Fehler beim Laden: {{label}}',
  tryAgain: 'Erneut versuchen',
  noDataFound: 'Keine Daten gefunden',
  unknownEntityType: 'Unbekannter Entitätstyp: {{type}}',
};

const detailDrawer = { en, de };
export default detailDrawer;
